import React from "react";
import AppContext from "../../components/AppContext";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import PageHeader from "../../components/PageHeader";
import { removeSlashesFromPath } from "../../helpers/location/removeSlashesFromPath";
import MainUI from "./mainUI";
class BuyCredit extends React.Component {
  static contextType = AppContext;

  componentDidMount() {}
  render() {
    const { isInbox, t } = this.props;
    const { allBankAccountData, isMerchantData } = this.context;
    let payinFee = isMerchantData?.depositFeePercentage;
    return (
      <>
        <div style={{ flex: 1 }}>
          <div>
            <div className="container-fluid">
              <PageHeader
                HeaderText={t("BuyCredit")}
                Breadcrumb={
                  isInbox
                    ? [
                        {
                          name: removeSlashesFromPath(window.location.pathname),
                          navigate: window.location.pathname,
                        },
                      ]
                    : []
                }
              />
              {isInbox && (
                <>
                  <MainUI
                    payinFee={payinFee}
                    merchantInfo={isMerchantData}
                    allBankAccountData={allBankAccountData || []}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = ({ mailInboxReducer }) => ({
  isInbox: mailInboxReducer.isInbox,
});
export default connect(mapStateToProps, null)(withTranslation()(BuyCredit));
